module.exports = __webpack_public_path__ + "img/logo-small.d26994b7.png";